import axios from 'axios';

const url = '/api/configuration/project-group';

export const LICENSE_SAVED_EVENT = 'NEW_LICENSE_SAVED';

class LicenseService {
    constructor($rootScope) {
        'ngInject';
        this.$rootScope = $rootScope;
    }

    get(companyId) {
        return axios.get(`${url}/company-license`, {params: {companyId}})
            .then(response => response.data);
    }

    save(companyId, licenseId) {
        return axios.post(`${url}/update-license`, {companyId, licenseId})
            .then(response => {
                this.$rootScope.$broadcast(LICENSE_SAVED_EVENT);
                return response.data
            })
    }


}

export default LicenseService;


// WEBPACK FOOTER //
// ./components/popups/license-popup/license.service.js